import { Subject } from 'rxjs';

export enum CampaignPageEventType {
  SEARCH = 'SEARCH',
}

export enum SearchPageEventType {
  SEARCH = 'SEARCH',
}

export const campaignPageEvent$ = new Subject<{
  payload?: any;
  type: CampaignPageEventType;
}>();

export const searchPageEvents$ = new Subject<{
  payload?: any;
  type: SearchPageEventType;
}>();
